import { Button } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useInboxInvoices } from "Shared/hooks/expense.hooks"

export interface UploadFileDraggerContentInterface {
    label: {
        buttonLabel: string
        draggerDescription: string
    }
    isUploading?: boolean
    onInboxSelected?: (event: any) => void
}

const UploadFileDraggerContent: React.FC<UploadFileDraggerContentInterface> = ({ label, isUploading, onInboxSelected }) => {
    const { t } = useTranslation()
    const inboxInvoiceData = onInboxSelected && useInboxInvoices()

    return (
        <>
            <i className="el-icon-upload" />
            <div className="el-upload__text">
                {onInboxSelected && inboxInvoiceData && inboxInvoiceData.count > 0 && (
                    <Button className="mt-10 mr-8" onClick={onInboxSelected}>
                        {t("action:inbox_invoice.inbox")}
                    </Button>
                )}
                <Button loading={isUploading}>{label.buttonLabel}</Button>
                <br />
                <small>{label.draggerDescription}</small>
            </div>
        </>
    )
}

export default UploadFileDraggerContent
